<!-- @if (showSpinner) {
<app-loader> </app-loader>
} -->

<div class="main-wrapper">
  <div class="outer-wrapper">
    @if (PayrollChecks('isSumary')) {
    <div class="payroll-summary-header">
      <div class="payroll-summary-header-head">
        <h1 *ngIf="!showSkeleton" style="display: flex; align-items: center; gap: 10px;">
          Payroll Summary
          <img style="cursor: pointer; width: 18px;" *ngIf="payrollService.showValues"
            (click)="payrollService.toggleShowValues()" src="../../../../assets/theme1/smal-icons/eye-purple.svg"
            alt="Hide" />
          <svg style="cursor: pointer; width: 18px;" *ngIf="!payrollService.showValues"
            (click)="payrollService.toggleShowValues()" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24" fill="none" stroke="#6b46c1" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path
              d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
            </path>
            <line x1="1" y1="1" x2="23" y2="23"></line>
          </svg>
        </h1>

        <div class="form-group custom-select-wrapper" *ngIf="!showSkeleton">
          <select class="form-control custom-select" [(ngModel)]="selectedMonthYear"
            (ngModelChange)="onMonthChange($event)">
            <option value="" disabled selected hidden>Select Month</option>
            <option *ngFor="let monthObj of months" [value]="monthObj.month + '-' + monthObj.year">
              {{ monthObj.label }} {{ monthObj.year }}
            </option>
          </select>

          <span class="custom-arrow">
            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.75 0.75L5.75 5.75L10.75 0.75" stroke="#555555" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
        </div>
        <div class="payroll-summary-header-body-item release-amount skeleton-small-div" *ngIf="showSkeleton"></div>
        <div class="payroll-summary-header-body-item release-amount skeleton-small-div" *ngIf="showSkeleton"></div>

      </div>
      <div class="payroll-summary-header-body">

        <div class="payroll-summary-header-body-item release-amount" *ngIf="!showSkeleton && !summarySkeleton">
          <div class="card-head">
            <div class="card-img">
              <img src="../../../../assets/theme1/smal-icons/release-amount.png" />
            </div>
            <div class="card-content">
              <p><span>Total</span> Released Amount</p>
              <h2>{{ payrollService.showValues ? (summaryTotalReleased ?? 0 | number:'1.2-2') + '/- PKR' : '****' }}
                <span *ngIf="payrollService.showValues"
                  [ngClass]="{'text-green': isPositive(releasedsummaryPercentage), 'text-red': !isPositive(releasedsummaryPercentage)}">
                  ({{ releasedsummaryPercentage ?? 0 }})
                </span>
              </h2>
            </div>
          </div>
        </div>
        <div class="payroll-summary-header-body-item gross-amount" *ngIf="!showSkeleton && !summarySkeleton">
          <div class="card-head">
            <div class="card-img">
              <img src="../../../../assets/theme1/smal-icons/gross-salary.png" />
            </div>
            <div class="card-content">
              <p><span>Total</span> Gross Salary</p>
              <h2>{{ payrollService.showValues ? (summaryTotalgross ?? 0 | number:'1.2-2') + '/- PKR' : '****' }}</h2>
            </div>
          </div>
        </div>
        <div class="payroll-summary-header-body-item dedution-amount" *ngIf="!showSkeleton && !summarySkeleton">
          <div class="card-head">
            <div class="card-img">
              <img src="../../../../assets/theme1/smal-icons/total-deduction.png" />
            </div>
            <div class="card-content">
              <p><span>Total</span> Deductions</p>
              <h2>{{ payrollService.showValues ? (summaryTotaldeduction ?? 0 | number:'1.2-2') + '/- PKR' : '****' }}</h2>
            </div>
          </div>
        </div>
        <div class="payroll-summary-header-body-item pending-amount" *ngIf="!showSkeleton && !summarySkeleton">
          <div class="card-head">
            <div class="card-img">
              <img src="../../../../assets/theme1/smal-icons/pending-payroll.png" />
            </div>
            <div class="card-content">
              <p><span>Total</span> Pending Payrolls</p>
              <h2>{{ payrollService.showValues ? (summaryPendingTotal ?? 0 | number:'1.2-2') + '/- PKR' : '****' }}</h2>
            </div>
          </div>
        </div>
        <div class="payroll-summary-header-body-item final-amount" *ngIf="!showSkeleton && !summarySkeleton">
          <div class="card-head">
            <div class="card-img">
              <img src="../../../../assets/theme1/smal-icons/final-settlement.png" />
            </div>
            <div class="card-content">
              <p><span>Total</span> Final Settlement</p>
              <h2>{{ payrollService.showValues ? (summaryFinalsettlement ?? 0 | number:'1.2-2') + '/- PKR' : '****' }}</h2>
            </div>
          </div>
        </div>

        <div class="payroll-summary-header-body-item release-amount skeleton-div"
          *ngIf="showSkeleton || summarySkeleton"></div>
        <div class="payroll-summary-header-body-item release-amount skeleton-div"
          *ngIf="showSkeleton || summarySkeleton"></div>
        <div class="payroll-summary-header-body-item release-amount skeleton-div"
          *ngIf="showSkeleton || summarySkeleton"></div>
        <div class="payroll-summary-header-body-item release-amount skeleton-div"
          *ngIf="showSkeleton || summarySkeleton"></div>
        <div class="payroll-summary-header-body-item release-amount skeleton-div"
          *ngIf="showSkeleton || summarySkeleton"></div>

      </div>
    </div>
    <div class="payroll-summary-body">
      <div class="payroll-main-graphs">
        <div class="common-graph-section column-graph-main" *ngIf="!showSkeleton && !graphSkeleton">

          <div class="payroll-summary-header-head">
            <h1>Payroll Trend Graph <span class="small-text">(Yearly)</span></h1>
            <div class="form-group custom-select-wrapper">
              <select class="form-control custom-select" id="yearSelect" name="yearSelect" [(ngModel)]="currentYear"
                (ngModelChange)="onYearChange($event)">
                <option value="" disabled selected hidden>Select Year</option>
                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
              </select>
              <span class="custom-arrow">
                <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.75 0.75L5.75 5.75L10.75 0.75" stroke="#555555" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
            </div>
          </div>
          <div class="column-cart" >
            <ng-container *ngIf="lineChartOptions && !noDataAvailable"  >
              <apx-chart [series]="lineChartOptions.series" [chart]="lineChartOptions.chart"
                [xaxis]="lineChartOptions.xaxis" [dataLabels]="lineChartOptions.dataLabels"
                [stroke]="lineChartOptions.stroke" [legend]="lineChartOptions.legend"
                [colors]="lineChartOptions.colors">
              </apx-chart>
            </ng-container>
            <div class="no-data-image" *ngIf="noDataAvailable">
              <img src="../../../../assets/theme1/nodata.png" alt="No Data" class="no-data-image">
              <p>No data available for this month.</p>
            </div>
          </div>

        </div>
        <div class="common-graph-section column-graph-main skeleton-big-div" *ngIf="showSkeleton || graphSkeleton">
        </div>

        <div class="common-graph-section department-grpah" *ngIf="!showSkeleton && !departmentSkeleton ">
          <div class="payroll-summary-header-head">
            <h1>Department Payroll</h1>
            <div class="form-group custom-select-wrapper">

              <select class="form-control custom-select" [(ngModel)]="selecteddepMonthYear"
                (ngModelChange)="ondepMonthChange($event)">
                <option value="" disabled selected hidden>Select Month</option>
                <option *ngFor="let monthObj of months" [value]="monthObj.month + '-' + monthObj.year">
                  {{ monthObj.label }} {{ monthObj.year }}
                </option>
              </select>
              <span class="custom-arrow">
                <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.75 0.75L5.75 5.75L10.75 0.75" stroke="#555555" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
            </div>
          </div>


          <div class="department-donut-chart" *ngIf="showDepartmentChart">
            <apx-chart [series]="newChartOptions.series" [chart]="newChartOptions.chart"
              [labels]="newChartOptions.labels" [colors]="newChartOptions.colors"
              [plotOptions]="newChartOptions.plotOptions" [dataLabels]="newChartOptions.dataLabels"
              [stroke]="newChartOptions.stroke" [legend]="newChartOptions.legend"
              [responsive]="newChartOptions.responsive">
            </apx-chart>

            <!-- Custom legend grid -->
            <div class="department-grid">
              <div class="department-item" *ngFor="let dept of newChartOptions.labels; let i = index">
                <span class="color-box" [style.backgroundColor]="newChartOptions.colors[i]"></span>
                <span class="dept-name">{{ dept }} ({{ newChartOptions.series[i] }}%)</span>
              </div>
            </div>
          </div>

          <!-- No data placeholder -->
          <div class="no-department-data" *ngIf="showNoDataImage">
            <img src="../../../../assets/theme1/no-data.jpg" alt="No data available" />
            <p>No department data available for this month.</p>
          </div>


        </div>


        <div class="common-graph-section department-grpah skeleton-big-div" *ngIf="showSkeleton || departmentSkeleton">
        </div>


      </div>
    </div>
    }
    @if (PayrollChecks('ismonthly')) {
    <div class="payroll-summary-footer">
      <div class="payroll-subcomponent common-graph-section">
        <div class="common-head">
          <div class="comon-left-head borderless">
            <h1 *ngIf="!showSkeleton">Monthly Payroll Details</h1>
            <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
              *ngIf="showSkeleton"></div>

          </div>
          <div class="comon-right">
            <div *ngIf="!showSkeleton && reviewButton" class="common-btn review-info" (click)="goPreviewPayroll()">
              <img src="../../../../assets/theme1/smal-icons/orage-eye.svg" alt="missing icon">
              Review Submitted Payroll
            </div>
            @if (PayrollChecks('isDetail')) {
            <div *ngIf="!showSkeleton" class="common-btn salary-info" (click)="goToAddPayroll()">
              <img src="../../../../assets/theme1/smal-icons/salry-info-btn.svg" alt="missing icon">
              Employee Salary Info
            </div>
            }
            @if (PayrollChecks('isAdd')) {
            <div *ngIf="!showSkeleton" class="common-btn request-loan" data-toggle="modal" data-target="#payrollModal">
              <img src="../../../../assets/theme1/smal-icons/plus-circle.svg" alt="missing icon">
              Add New Payroll
            </div>
            }

            <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
              *ngIf="showSkeleton"></div>
            <div class="payroll-summary-header-body-item release-amount skeleton-small-div skiliton-buttons"
              *ngIf="showSkeleton"></div>
          </div>
        </div>

        <!-- <div class="filter-section">
                        <h1>Filter</h1>
                        <div class="filter-fields">
                           
                             
                            <button class="apply-filter" >Apply</button>
                        </div>
                    </div> -->

        <div class="table-container">
          <table class="responsive-table">
            <thead>

              <tr>
                <th>Month</th>
                <th>Release Date</th>
                <th>Gross Salary</th>
                <th>Net Salary</th>
                <th *ngIf="hasOverTime">Over Time</th>
                <th *ngIf="hasLoan">Loan</th>
                <th *ngIf="hasAdvance">Advance</th>
                <th *ngIf="hasCompensation">Compensation</th>
                <th *ngIf="hasTax">Tax</th>
                <th *ngIf="hasTotalDeduction">Total Deduction</th>
                <th>Status</th>
                @if (PayrollChecks('isPreview')) {
                <th>Action</th>
                }
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="showSkeleton">
                <td colspan="12">
                  <div class="skeleton-row" *ngFor="let n of [1,2,3,4,5]">
                    <div class="skeleton-cell" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12]"></div>
                  </div>
                </td>
              </tr>
              <ng-container *ngIf="!showSkeleton">
                <tr [ngClass]="getStatusClassForTd(payroll.status)" *ngFor="let payroll of payrollList">
                  @if (PayrollChecks('isPreview')) {
                    <td class="first-td" (click)="openPreview(payroll)">{{ payroll.month }}</td>
                  } @else {
                    <td class="first-td" >{{ payroll.month }}</td>
                  }
                  
                  

                  <td>{{ payroll.release_date || '- -'}}</td>
                  <td>{{ payrollService.showValues ? (payroll.gross_salary | number) : '****' }}</td>
                  <td>{{ payrollService.showValues ? (payroll.net_salary | number) : '****' }}</td>
                  <td *ngIf="hasOverTime">{{ payrollService.showValues ? (payroll.over_time | number) : '****' }}</td>
                  <td *ngIf="hasLoan">{{ payrollService.showValues ? (payroll.loan | number) : '****' }}</td>
                  <td *ngIf="hasAdvance">{{ payrollService.showValues ? (payroll.advance | number) : '****' }}</td>
                  <td *ngIf="hasCompensation">{{ payrollService.showValues ? (payroll.compensation | number) : '****' }}
                  </td>
                  <td *ngIf="hasTax">{{ payrollService.showValues ? (payroll.tax | number) : '****' }}</td>
                  <td *ngIf="hasTotalDeduction">{{ payrollService.showValues ? (payroll.total_deduction | number) :
                    '****' }}
                    <img class="deduction-detail" src="../../../../assets/theme1/info-circle_blk.svg"
                      data-toggle="modal" data-target="#deductionModal" alt="missing icon"
                      (click)="openDeductionModal(payroll)" />
                  </td>
                  <td>
                    <div [ngClass]="'status-comon ' + getStatusClass(payroll.status)">
                      {{ getStatusText(payroll.status) }}

                      <!-- Tooltip only for change_required -->
                      <div *ngIf="payroll.status === 'change_required'" class="custom-tooltip">
                        <img src="../../../../assets/theme1/info-circle_blk.svg" alt="info icon" />
                        <span class="tooltip-text">Attendance data conflict. Please recheck employee presence</span>
                      </div>
                    </div>
                  </td>
                  @if (PayrollChecks('isPreview')) {
                  <td class="action-eye">
                    <img (click)="openPreview(payroll)" src="../../../../assets/theme1/smal-icons/eye-purple.svg"
                      alt="eye icon" />
                  </td>

                  }

                </tr>
              </ng-container>


            </tbody>
          </table>
        </div>


      </div>




    </div>
    }

  </div>
</div>




<div class="modal fade payroll-modal pl-0" id="payrollModal" tabindex="-1" role="dialog" aria-labelledby="basicModal"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content payroll-modal-content">
      <div class="modal-header payroll-modal-header justify-content-center">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <img src="../../../../assets/theme1/smal-icons/circle-black-cross.png" alt="image">
        </button>
      </div>

      <div class="modal-body payroll-modal-body text-center payroll-modal-body">
        <img src="../../../../assets/theme1/smal-icons/calendar-3d.png" alt="image">
        <h1 class="mt-3">Select Month</h1>
        <div class="month-picker">
          <div class="month-picker-header">
            <button (click)="prevYear()">
              <img src="../../../../assets/theme1/smal-icons/left-arrow.png" alt="missing icon">
            </button>
            <span>{{ modalcurrentYear }}</span>
            <button (click)="nextYear()">
              <img src="../../../../assets/theme1/smal-icons/right-arrow.png" alt="missing icon">
            </button>
          </div>

          <div class="month-grid">
            <div *ngFor="let month of modalmonths; let i = index" class="month-cell"
              [class.selected]="i === selectedMonth" (click)="payrolselectMonth(i)">
              {{ month }}
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>




<!-- deduction modal -->

<div class="modal fade payroll-modal pl-0" id="deductionModal" tabindex="-1" role="dialog" aria-labelledby="basicModal"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content payroll-modal-content">
      <div class="modal-header payroll-modal-header justify-content-center deduction-header">
        <h1>Total Deductions</h1>
        <button type="button" class="close deduction-close" data-dismiss="modal" aria-label="Close">
          <img src="../../../../assets/theme1/smal-icons/black-cross.svg" alt="image" />
        </button>
      </div>

      <div class="modal-body payroll-modal-body deduction-modal-body">
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head">
              <h1 class="title-head">Category</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head">
              <h1 class="title-head">Duration</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1 class="title-head">Deduction</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Absents</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>{{ selectedPayroll?.detailed_deductions?.Absents?.count | number }}</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>{{ payrollService.showValues ? (selectedPayroll?.detailed_deductions?.Absents?.amount | number) +
                '/-PKR' : '****' }}</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Late Check In</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>{{ selectedPayroll?.detailed_deductions?.Late_Check_In?.duration ?? 00 }}</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>{{ payrollService.showValues ? (selectedPayroll?.detailed_deductions?.Late_Check_In?.amount ?? 0) +
                '/-PKR' : '****' }}</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Short Hours</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>{{ selectedPayroll?.detailed_deductions?.Short_Hours?.duration ?? 00}}</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>{{ payrollService.showValues ? (selectedPayroll?.detailed_deductions?.Short_Hours?.amount ?? 0) +
                '/-PKR' : '****' }}</h1>
            </div>
          </div>
        </div>
        <div class="dedcution-modal-table">
          <div class="comon-div-main deduction-category">
            <div class="comon-div modal-comon-head category-head">
              <h1>Unpaid Leaves</h1>
            </div>
          </div>
          <div class="comon-div-main deduction-duration">
            <div class="comon-div modal-comon-head duration-text-center">
              <h1>{{ selectedPayroll?.detailed_deductions?.Unpaid_Leaves?.count ?? 00}}</h1>
            </div>
          </div>
          <div class="comon-div-main final-deduction">
            <div class="comon-div modal-comon-head">
              <h1>{{ payrollService.showValues ? (selectedPayroll?.detailed_deductions?.Unpaid_Leaves?.amount ?? 0) +
                '/-PKR' : '****' }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>